/**
 * App Entry File
 * Vuely: A Powerfull Material Design Admin Template
 * Copyright 2018. All Rights Reserved
 * Created By: The Iron Network, LLC
 * Made with Love
 */
import "babel-polyfill";
import Vue from "vue";
import Vuetify from "vuetify";
import VueBreadcrumbs from "vue2-breadcrumbs";
import VueResource from "vue-resource";
import Notifications from "vue-notification";
import velocity from "velocity-animate";
import Nprogress from "nprogress";
import VueI18n from "vue-i18n";
import fullscreen from "vue-fullscreen";
import Swal from "sweetalert2/dist/sweetalert2.js";
import {
  formatTimeServer,
  translateText,
  translateWalletName,
  translateBuildingName,
  translateAgentName,
  formatCurrency,
} from "Helpers";
import VueCurrencyInput from "vue-currency-input";

window.swal = Swal;

// filter
Vue.filter("formatNumber", function(x) {
  return x ? x.toLocaleString("vi-VI") : 0;
});
Vue.filter("formatTimeServer", function(x) {
  return x ? formatTimeServer(x) : "";
});
Vue.filter("formatTimeDetail", function(x) {
  return x ? formatTimeServer(x, "DD-MMM-YYYY H:mm:ss ") : "";
});
Vue.filter("formatTimeVN", function(x, customFormat = "DD/MM/YYYY") {
  return x ? formatTimeServer(x, customFormat) : "";
});
Vue.filter("translateText", function(x) {
  return x ? translateText(x) : "";
});
Vue.filter("translateWalletName", function(x) {
  return x ? translateWalletName(x) : "";
});
Vue.filter("translateBuildingName", function(x) {
  return x ? translateBuildingName(x) : "";
});
Vue.filter("translateAgentName", function(agent_id) {
  return agent_id ? translateAgentName(agent_id) : "";
});
Vue.filter("toLocaleMonth", function(month) {
  return new Date(month + "-01").toLocaleDateString("en-GB").substr(3);
});
Vue.filter("formatCurrency", formatCurrency);

Vue.filter("translateAccountName", function(accountValue) {
  if (accountValue && ACCOUNTS[accountValue] && ACCOUNTS[accountValue].text) {
    return ACCOUNTS[accountValue].text;
  }
  return accountValue;
});

Vue.filter("translateAccountingAccountToName", function(accounting_account) {
  if (accounting_account && ACCOUNTING_ACCOUNT_DISPLAY_NAME_MAPPING[accounting_account]) {
    return ACCOUNTING_ACCOUNT_DISPLAY_NAME_MAPPING[accounting_account];
  }
  return "N/A";
});

// global components
import GlobalComponents from "./globalComponents";

// app.vue
import App from "./App";

// router
import router from "./router";

// themes
import primaryTheme from "./themes/primaryTheme";

// store
import { store } from "./store/store";

// include script file
import "./lib/VuelyScript";

// include all css files
import "./lib/VuelyCss";
import "sweetalert2/src/sweetalert2.scss";

// messages
import messages from "./lang";
import { ACCOUNTS, ACCOUNTING_ACCOUNT_DISPLAY_NAME_MAPPING } from "./constants/db-config";

// navigation guards before each
router.beforeEach((to, from, next) => {
  Nprogress.start();
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    // this route requires auth, check if logged in
    // if not, redirect to login page.
    if (!localStorage.getItem("token")) {
      next({
        path: "/login",
        query: { redirect: to.fullPath },
      });
    }
    if (
      to.matched.some((record) => record.meta.requiresAdmin) &&
      localStorage.getItem("role") !== "admin"
    ) {
      next("/");
    } else {
      next();
    }
  } else {
    next(); // make sure to always call next()!
  }
});

// navigation guard after each
router.afterEach((to, from) => {
  Nprogress.done();
  setTimeout(() => {
    const contentWrapper = document.querySelector(".v-content__wrap");
    if (contentWrapper !== null) {
      contentWrapper.scrollTop = 0;
    }
    const boxedLayout = document.querySelector(
      ".app-boxed-layout .app-content"
    );
    if (boxedLayout !== null) {
      boxedLayout.scrollTop = 0;
    }
    const miniLayout = document.querySelector(".app-mini-layout .app-content");
    if (miniLayout !== null) {
      miniLayout.scrollTop = 0;
    }
  }, 200);
});

// plugins
Vue.use(Vuetify, {
  theme: store.getters.selectedTheme.theme,
});
Vue.use(VueI18n);
Vue.use(VueResource);
Vue.use(VueBreadcrumbs);
Vue.use(Notifications, { velocity });
Vue.use(Notifications);
Vue.use(fullscreen);
Vue.use(GlobalComponents);
const pluginOptions = {
  globalOptions: {
    currency: "VND",
    locale: "vi-VI",
  },
};

Vue.use(VueCurrencyInput, pluginOptions);
// Create VueI18n instance with options
const i18n = new VueI18n({
  locale: store.getters.selectedLocale.locale, // set locale
  messages, // set locale messages
});

/* eslint-disable no-new */
new Vue({
  store,
  i18n,
  router,
  render: (h) => h(App),
  components: { App },
}).$mount("#app");
